import errorMap from '@gap/backend/util/validations/validation-error-map'
import { z } from 'zod'

export const ProposalAttachmentSchema = z.object({
   link: z.string({ errorMap }).optional(),
   linkName: z.string({ errorMap }).optional(),
   fileName: z.string({ errorMap }).optional(),
})

export type ProposalAttachment = z.infer<typeof ProposalAttachmentSchema>

export const ProposalStep5DtoSchema = z.object({
   personalMessage: z.string({ errorMap }).min(1).optional(),
   attachments: z.array(ProposalAttachmentSchema).optional(),
})

export type ProposalStep5Dto = z.infer<typeof ProposalStep5DtoSchema>
